var $ = require("jquery");

(function () {
    var expandableClose = '[data-expandable-container="close"]';
    var expandable = '[data-expandable]';
    var expandableToggle = '[data-expandable-toggle]';
    var expandableContent = '[data-expandable-content]';

    $(document).on('click', expandableToggle, toggleClick);

    function toggleClick(e) {
        var $self = $(this);
        var $expandable = $self.closest(expandable)
        var $container = $self.closest(expandableClose);
        var isOpen = $expandable.hasClass('open')


        if ($container.length > 0) {
            var toggles = $container.find(expandableToggle, false);
            $(toggles).each(function (x, item) {
                toggleExpand($(item), false);
            });
        }

        
        toggleExpand($self, !isOpen);
    }

    function toggleExpand(self, open) {
        var $expandable = self.closest(expandable)
        var $content = $expandable.find(expandableContent);
        var arrowIcon = $expandable.find(".Icon");

        if (open) {
            $expandable.addClass('open');
            $content.slideDown('fast');

            self.attr('aria-expanded', 'true');
            //self.toggleClass('collapsed');

            arrowIcon.addClass("-open");
        }
        else {
            $expandable.removeClass('open');
            $content.slideUp('fast');

            
            self.attr('aria-expanded', 'false');
            //self.toggleClass('collapsed');

            arrowIcon.removeClass("-open");
        }
    }
})();